import { render, staticRenderFns } from "./inventoryTable.vue?vue&type=template&id=0932bd7d&"
import script from "./inventoryTable.vue?vue&type=script&lang=js&"
export * from "./inventoryTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports